export default "__VITE_ASSET__$iHqmlId__"